import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  ScrollView,
} from "react-native";
import moment from "moment";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import i18n from "@microdoing/shared/i18n";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { Loading, Header } from "../../components/common";
import theme from "app/Theme/Theme";

const tracksData = [
  {
    title: "Bienvenue chez Microdoing",
    _id: "123",
    description:
      "Un parcours d'onboarding pour que tu te sentes comme un start chez nous",
    tags: ["Soft Skills", "Onboarding"],
    label: "essential",
    noProgress: true,
    steps: [
      {
        done: true,
        title: "Valorisez vos équipes",
        date: moment().subtract(10, "day"),
      },
      { done: true, title: "Écoute active" },
      { done: true, title: "Feedback précis et positif" },
      { done: true, title: "Valorisez vos équipes" },
      { done: true, title: "Écoute active" },
      { done: true, title: "Feedback précis et positif" },
      { status: "selected", title: "Leadership" },
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
    ],
    progress: 0.6,
    picture:
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=80",
  },
  {
    _id: "456",
    title: "Maitrise des soft skills",
    description:
      "Des défis qui s’adaptent à votre personnalité et vous vont grandir au quotidien !",
    tags: ["Soft Skills", "Onboarding"],
    picture:
      "https://images.unsplash.com/photo-1500320821405-8fc1732209ca?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
    label: "popular",
  },
];

class SeeTrackScreen extends Component {
  state = {};

  actionDate = date => {
    const today = moment();
    const doneDate = moment(date);
    const diff = today.diff(doneDate, "days");
    if (diff === 0) {
      return i18n.t("today");
    } else if (diff === 1) {
      return i18n.t("yesterday");
    }
    return i18n.t("ago", { days: diff });
  };

  isDisabled = now => {
    const isTime = now.diff(moment(this.props.actionSeenDate), "minute");
    return this.props.historical.length >= 1 && isTime < 1;
  };

  keyExtractor = (item, index) => {
    return index.toString();
  };

  getItemLayout = (data, index) => ({
    length: wp("18%") + 23,
    offset: (wp("18%") + 23) * index,
    index,
  });

  goBack = () => {
    this.props.navigation.goBack();
  };

  getUserTracks = () => {
    console.log("getting user tracks");
  };

  setScrollViewRef = element => {
    this.scrollViewRef = element;
  };

  renderSteps = data => {
    const step = data.item;
    const stepNumber = data.index;

    return null;
  };

  render() {
    return (
      <View style={styles.main}>
        <Header
          backgroundColor={theme.colors["brand.500"]}
          name={i18n.t("add-track")}
          onPress={() => this.props.navigation.goBack()}
        />
        <ScrollView
          getItemLayout={this.getItemLayout}
          keyExtractor={this.keyExtractor}
          keyboardShouldPersistTaps="always"
          onRefresh={this.getUserTracks}
          refreshing={this.props.requesting || false}
          ListHeaderComponent={this.props.requesting && <Loading />}
          onEndThreshold={0.1}
        >
          <View style={styles.space} />

          {tracksData[0].steps.map((item, index) => {
            return this.renderSteps({ item, index });
          })}
        </ScrollView>
        <TouchableOpacity style={styles.button}>
          <Text style={styles.buttonText}>{i18n.t("start-track")}</Text>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = {
  main: {
    flex: 1,
    backgroundColor: theme.colors["neutral.white"],
    flexDirection: "column",
  },
  title: {
    fontSize: wp("6.2%"),
    color: theme.colors["neutral.900"],
    fontWeight: "bold",
    marginTop: Platform.OS === "ios" ? 15 : 10,
    marginBottom: 15,
    marginLeft: 20,
    marginRight: 20,
  },
  text: {
    color: theme.colors["neutral.900"],
    fontSize: wp("4%"),
  },
  scrollView: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  space: {
    marginTop: 5,
    marginBottom: 5,
  },
  button: {
    position: "absolute",
    bottom: 15,
    alignSelf: "center",
    width: wp("60%"),
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors["brand.500"],
    paddingTop: 10,
    paddingBottom: 10,
  },
  buttonText: {
    color: theme.colors["neutral.white"],
    fontWeight: "bold",
    fontSize: wp("4%"),
  },
};

const mapStateToProps = state => {
  const { actionState } = state.action;
  const { manager, repetition, client, companyLogo } = state.user;
  return {
    companyLogo,
    actionState,
    user: state.user,
    teamRank: 1,
    userRank: 8,
    timezone: state.user.timezone,
    firstName: state.user.firstName,
    historical: [{}, {}],
    userId: getUserId(state),
  };
};

export default connect(mapStateToProps, {})(SeeTrackScreen);
